import { Menu } from 'antd'
import styled from 'styled-components'

export default styled(Menu)`
  background-color: transparent;
  color: black;
  border: none;

  li {
    margin: ${({ theme }) => theme.spacing.spacing16}px ${({ theme }) => theme.spacing.spacing8}px !important;
    border-radius: ${({ theme }) => theme.main}px;
    color: ${({ theme }) => theme.colors.smoke};
    font-weight: bold;

    .ant-menu-title-content {
      a {
        color: ${({ theme }) => theme.colors.smoke};
      }
      &:hover {
        a {
          color: ${({ theme }) => theme.colors.primary} !important;
        }
      }
    }

    &.ant-menu-item-selected {
      color: ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.light} !important;
      a {
        color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
  }
`
